'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_ImmuDBDataCenterId() {
}
export { $c_Lapp_data_ImmuDBDataCenterId as $c_Lapp_data_ImmuDBDataCenterId };
$p = $c_Lapp_data_ImmuDBDataCenterId.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_ImmuDBDataCenterId;
/** @constructor */
function $h_Lapp_data_ImmuDBDataCenterId() {
}
export { $h_Lapp_data_ImmuDBDataCenterId as $h_Lapp_data_ImmuDBDataCenterId };
$h_Lapp_data_ImmuDBDataCenterId.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
var $d_Lapp_data_ImmuDBDataCenterId = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i(0, "app.data.ImmuDBDataCenterId", ({
  jB: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_ImmuDBDataCenterId as $d_Lapp_data_ImmuDBDataCenterId };
//# sourceMappingURL=app.data.-Immu-D-B-Data-Center-Id.js.map
